// getIsReturningFocus is used to determine whether focus should return to
// the meatball trigger once an option is clicked.
export const getIsReturningFocus = (
	e?: React.KeyboardEvent | React.MouseEvent | KeyboardEvent,
	shouldHaveFocus = true,
) => (e?.detail ?? 0) === 0 && shouldHaveFocus;
